import React, { useContext } from "react";
import { Box, Button, Main, ResponsiveContext, Heading } from "grommet";
import config from "../config";
import header_image from "../static/img/bg_competitive.jpg";

export const LandingPage = () => {
	const size = useContext(ResponsiveContext);
	// function generateRandomString(length) {
	// 	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	// 	let result = '';
	// 	const randomValues = new Uint32Array(length);
	// 	window.crypto.getRandomValues(randomValues);
	// 	for (let i = 0; i < length; i++) {
	// 		result += characters.charAt(randomValues[i] % characters.length);
	// 	}
	// 	return result;
	// }

	// async function encryptString(text, key) {
	// 	const textEncoder = new TextEncoder();
	// 	const data = textEncoder.encode(text);
	// 	const iv = window.crypto.getRandomValues(new Uint8Array(12));
	// 	const algorithm = { name: 'AES-GCM', iv: iv };
	// 	const jwk = await window.crypto.subtle.importKey(
	// 		'raw',
	// 		textEncoder.encode(key),
	// 		algorithm,
	// 		false,
	// 		['encrypt', 'decrypt']
	// 	);
	// 	const encryptedData = await window.crypto.subtle.encrypt(algorithm, jwk, data);
	// 	const encryptedArray = Array.from(new Uint8Array(encryptedData));
	// 	const ivArray = Array.from(iv);
	// 	const combinedArray = ivArray.concat(encryptedArray);
	// 	const encryptedHex = combinedArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
	// 	return encryptedHex;
	// }
	const handleClick = async () => {
		const state = Math.random().toString(36).substring(2, 15);
		// const randomString = generateRandomString(32);
		// const encryptionKey = generateRandomString(16); // 16 bytes for AES-128
		// const encryptedString = await encryptString(randomString, encryptionKey);
		window.localStorage.setItem("state", state)
		window.location.href = `${config.ssoAuthorizationUrl}?client_id=${config.ssoClientID}&response_type=code&scope=openid profile&redirect_uri=${config.ssoRedirectURL}&state=${state}`;
	};

	return (
		<Main
			background={{ image: `url(${header_image})`, size: "cover", dark: true }}
			height='100%'
			pad={{ vertical: "xlarge", horizontal: "large" }}
			width='100%'
			align='center'
			justify='between'
			gap='large'
			direction='row'
		>
			<Box
				pad={size === "xlarge" ? "large" : "small"}
				width={size !== "small" ? "large" : "100%"}>
				<Heading color='white' margin='none' level={1} pad='large'>
					HPE Hybrid Cloud Sales Tool
				</Heading>
				<Box width='small' margin={{ top: "medium" }}>
					<Button label='Login' fontSize='18px' size='large' primary onClick={handleClick} />
				</Box>
			</Box>
		</Main>
	);
};

export default LandingPage;
